// extracted by mini-css-extract-plugin
export default {"container":"page_container__5s6UW"};